import { ICommonMissionState } from '../../missions/model/ICommonMissionState.ts';
import { Address } from '../../missions/components/Address.tsx';
import { Coordinates } from '../../missions/components/Coordinates.tsx';

export const Location: React.FC<{mission: ICommonMissionState}> = ({ mission }) => {
    const address = mission.getAddress();
    if (address) {
        return <Address address={address}/>;
    } else {
        return <Coordinates coordinates={mission.getLocation()}/>;
    }
};
